module.exports = __webpack_public_path__ + "img/image_loding.9682a6f9.png";